<template>
  <v-flex>
    <v-btn icon class="mx-0" @click.native="addUser"><v-icon>add</v-icon></v-btn>
    <v-data-table :headers="headers" :loading="loadingState" :items="users" hide-actions class="elevation-1" >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ props.item.id }}</td>
        <td class="text-xs-left">{{ props.item.firstName }}</td>
        <td class="text-xs-left">{{ props.item.lastName }}</td>
        <td class="text-xs-left">{{ props.item.company }}</td>
        <td class="text-xs-left">{{ props.item.email }}</td>
        <td class="justify-center layout px-0">
          <v-btn icon class="mx-0" @click.native="editUser(props.item.id)"><v-icon>edit</v-icon></v-btn>
          <v-btn icon class="mx-0" @click.native="deleteItem(props.item.id);"><v-icon>delete</v-icon></v-btn>
        </td>
      </template>
      <template slot="no-data">
        <v-alert :value="true" color="error" icon="warning" outline>No data available</v-alert>
      </template>
    </v-data-table>
  </v-flex>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapMutations } from 'vuex'

export default {
  data: function () {
    return {
      loadingState: true,
      headers: [
      { text: 'ID', align: 'left', value: 'id' },
      { text: 'First Name', align: 'left', value: 'firstName' },
      { text: 'Last Name', align: 'left', value: 'lastName' },
      { text: 'Company', align: 'left', value: 'company' },
      { text: 'Email', align: 'left', value: 'email' },
      { text: '', align: 'left', value: 'actions', sortable: false } ]
    }
  },
  computed: {
    ...mapGetters({
      users: 'getUsers'
    })
  },
  methods: {
    ...mapMutations('notification', ['notify']),
    getData () {
      axios.all([this.$store.dispatch('getUsers')]).then(axios.spread((usersResponse) => {
        this.loadingState = false
        if (usersResponse.data.status === 'SUCCESS') this.$store.commit('setUsers', usersResponse.data.payload)
      })).catch((err) => {
        this.loadingState = false
        this.notify({message: 'Something went wrong while connecting to the server.', show: true})
        console.log(err)
      })
    },
    editUser (id) {
      this.$router.push('/users/' + id)
    },
    addUser () {
      this.$router.push('/users/new')
    },
    deleteItem (id) {
      this.$vuetifyConfirmDialog.open('', 'Are you sure you want to delete this user?', 'Cancel', 'Delete').then(state => {
        if (state) {
          this.loadingState = true
          axios.all([this.$store.dispatch('deleteUser', {id: parseInt(id)})]).then(axios.spread((usersResponse) => {
            this.loadingState = false
            this.$store.commit('deleteUser', usersResponse.data.payload)
          })).catch((err) => {
            this.loadingState = false
            console.log(err)
          })
        }
      })
    }
  },
  mounted: function () {
    this.getData()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/users/UsersTable.vue